import { redirect } from "react-router-dom";

import { getFeatureFlag } from "src/app/featureFlags";

/**
 * Loader that gates the entire `/json-forms` route tree behind the
 * `enableJsonForms` AppConfig feature flag. Wraps the LOB selector,
 * every per-LOB pre-screen, and the schema-fetch lifecycle UI under
 * one parent route so the gate covers the full tree with one entry.
 *
 * When the flag is disabled or the lookup fails, the loader redirects
 * to the application home page so legacy claim-intake routes continue
 * to serve traffic without exposing the new flow.
 */
export const loader = async () => {
  try {
    const isEnabled = await getFeatureFlag("enableJsonForms");
    if (!isEnabled) {
      return redirect("/");
    }
    return null;
  } catch {
    return redirect("/");
  }
};
